import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlSignature } from './apiEndpoint';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Country } from './country';
import { Religion } from './religion';
import { City } from './city';
import { ProgrammeType } from './programmeType';
import { Title } from '../applicant/title';
import { Gender } from '../applicant/gender';
import { Region } from '../applicant/region';
import { CertificateProgramme } from './certificateprogramme';
import { Portfolio } from '../applicant/portfolio';
import { Response } from './response';
@Injectable()
export class CommonService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getReligion(): Observable<Religion[]> {
    const url = this.urlSignature.religionListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Religion[]));
  }

  getCountryList(): Observable<Country[]> {
    const url = this.urlSignature.countryListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Country[]));
  }

  getCityName(cityId: String): Observable<City> {
    const url = this.urlSignature.cityByIdUrl + cityId;
    return this.httpClient.get(url).pipe(map((response) => response as City));
  }

  getProgrammeTypes(): Observable<ProgrammeType[]> {
    const url = this.urlSignature.programmeTypesUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as ProgrammeType[]));
  }

  getTitleList(): Observable<Title[]> {
    const url = this.urlSignature.titleListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Title[]));
  }

  getGenderList(): Observable<Gender[]> {
    const url = this.urlSignature.genderListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Gender[]));
  }

  getRegionList(): Observable<Region[]> {
    const url = this.urlSignature.regionListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Region[]));
  }

  getPassPortPhotoUrl(photoName: string) {
    return this.urlSignature.photoLinkUrl + photoName;
  }

  getCertificateUrl(photoName: string) {
    return this.urlSignature.certificateLinkUrl + photoName;
  }

  getPortfolioUrl(portfolio: Portfolio) {
    if (portfolio.attachment.endsWith('.pdf')) {
      portfolio.attachmentUrl =
        this.urlSignature.acdtUrl + '/img/Adobe-PDF-Document-icon.png';
    } else {
      portfolio.attachmentUrl =
        this.urlSignature.acdtUrl +
        '/attachments' +
        this.urlSignature.environment +
        '/portfolios/' +
        portfolio.attachment;
    }
  }

  getCertificateProgrammeList(): Observable<CertificateProgramme[]> {
    const url = this.urlSignature.certificateProgrammeListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as CertificateProgramme[]));
  }

  getCurrentYear(): Observable<Response> {
    const url = this.urlSignature.currentYearUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Response));
  }

  getCountryName(countryId): Observable<Country[]> {
    const url = this.urlSignature.countryUrl + countryId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Country[]));
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
